import Decimal from 'decimal.js'
import { comma } from 'number-magic'
import dayjs from 'dayjs'

import OrionError from '../../../error/OrionError'

interface formatI {
  format(value: Date, targetFormat: string): string
  format(value: string, sourceFormat: string, targetFormat: string): string
}

export const formatDate: formatI['format'] = (p1: Date | string, p2: string, p3?: string) => {
  if (!p1) {
    return p1
  }

  if (p1 instanceof Date && typeof p2 === 'string') {
    const value = p1
    const format = p2

    if (!value) {
      throw new OrionError('value is null.')
    }

    if (!format) {
      throw new OrionError('format is null.')
    }

    return dayjs(value).format(format)
  } else if (typeof p1 === 'string' && typeof p2 === 'string' && typeof p3 === 'string') {
    const value = p1
    const sourceFormat = p2
    const targetFormat = p3

    if (!value || !sourceFormat || !targetFormat) {
      throw new OrionError(`Invalid arguments: ${value}, ${sourceFormat}, ${targetFormat}`)
    }

    if (dayjs(value, sourceFormat, true).isValid()) {
      return dayjs(value, sourceFormat).format(targetFormat)
    } else {
      throw new OrionError(`日期[${value}]与格式[${sourceFormat}]不匹配。`)
    }
  } else {
    throw new OrionError(`入参数量[${arguments.length}]不正确。`)
  }
}

function round(value: number, how: number) {
  const dec = new Decimal(value)
  return dec.toFixed(how, 4)
}

export function number2string(num: number | null | undefined, thousandsSeparatorValue: boolean, precisionValue: number, percentageValue: boolean): string {
  if (num === null || num === undefined) {
    return ''
  } else if (typeof num === 'number' || typeof num === 'string') {
    let result

    // 基础：先实现精度化
    if (precisionValue >= 0) {
      result = round(percentageValue ? num * 100 : num, precisionValue)
    } else {
      result = String(percentageValue ? num * 100 : num)
    }

    // 百分比优先级高于千分位，先实现百分比，再实现千分位
    if (percentageValue) {
      if (thousandsSeparatorValue) {
        // 千分位
        result = comma(result)
      }

      result += '%'
    } else if (thousandsSeparatorValue) {
      // 千分位
      // 小数精度优先级最高
      result = comma(result)
    }

    return result
  } else {
    throw new OrionError(`num [${num}]:[${typeof num}] is neither a number nor null.`)
  }
}

export const getSingleCodeContent = (
  options: Array<{
    value: string
    content: string
  }>,
  curValue: string
) => {
  if (!curValue) {
    return null
  }

  if (!options) {
    return curValue + '(?)'
  }

  for (let i = 0; i < options.length; i++) {
    const { value, content } = options[i]
    if (value == curValue) {
      return content
    }
  }

  return curValue + '(?)'
}

export const getMultiCodeContent = (
  options: Array<{
    value: string
    content: string
  }>,
  curValue: string
) => {
  if (!curValue) {
    return null
  }

  let content = ''

  const data = curValue.split(',')
  data.forEach((selectValue, valueIndex) => {
    const index = options.findIndex((item) => {
      if (item.value == selectValue) return true
    })

    if (index == -1) {
      content += `${selectValue}(?)`
    } else {
      content += options[index].content
    }

    if (valueIndex != data.length - 1) {
      content += ','
    }
  })

  return content
}
